<template>
    <div style="margin-top: 10px;margin-left: 30px;">
        <el-card shadow="hover" style="box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);">
            <el-row :gutter="20" justify="end">
                <el-col :span="6">
                    <el-button type="primary" v-if="currentName === ''" size="small" @click="goToRegistration">
                        待办中心
                    </el-button>
                </el-col>
                <el-col :span="12" v-if="currentName === ''" style="text-align: right">
                    <el-input v-model="keywords" placeholder="请输入内容关键字..." style="width: 300px"
                        @keydown.enter.native="doSearch"></el-input>
                    <el-button type="primary" icon="el-icon-search" @click="doSearch" style="margin-left: 15px">搜索
                    </el-button>
                </el-col>
            </el-row>
            <component v-bind:is="currentName" @changeName="changeName"></component>
            <div class="table" v-if="currentName === ''" style="margin-top: 20px; margin-left: 55px">
                <el-table :data="tableData" border style="width: fit-content" :cell-style="{ textAlign: 'center' }"
                    :header-cell-style="{ textAlign: 'center' }">



                    <el-table-column type="index" label="序号" :width="60">
                    </el-table-column>

                    <el-table-column prop="messageId" label="消息Id" :width="80" v-if="false">
                    </el-table-column>

                    <el-table-column prop="title" label="标题" :width="200">
                    </el-table-column>


                    <el-table-column prop="content" label="内容" :width="300">
                    </el-table-column>

                    <el-table-column prop="sendTime" label="发送时间" :width="200">
                    </el-table-column>


                    <el-table-column prop="state" label="状态" :width="150">
                        <template slot-scope="scope">
                            <span :style="{
                                color: scope.row.state == 0 ? '#999' :
                                    scope.row.state == 1 ? 'red' : 'green',
                                fontWeight: scope.row.state == 1 ? 'bold' : 'normal'
                            }">
                                {{ scope.row.state == 0 ? '已删除' :
                                    scope.row.state == 1 ? '待办' : '已办' }}
                            </span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="sender" label="发送人" :width="200">
                        <template slot-scope="scope">
                            {{ scope.row.sender === 'system' ? '平台审核人员' : scope.row.sender }}
                        </template>
                    </el-table-column>



                    <el-table-column label="操作" width="260">
                        <template slot-scope="scope">
                            <el-button size="mini" type="success" @click="handleEdit(scope.row)">标记已办
                            </el-button>
                            <el-button size="mini" type="success" @click="handleEdit1(scope.row)">标记待办
                            </el-button>
                            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-card>
        <div v-if="currentName === ''" class="block" style="position: absolute; left: 38%;margin-top: 20px">
            <el-pagination layout="prev, pager, next" :total="boardsTotal" :page-size="10" :current-page="currPage"
                @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import AddBoardContent from "../../components/AddBoardContent";

export default {
    name: "PublishBoard",
    data() {
        return {
            boardsTotal: 1,
            currPage: 1,
            keywords: '',
            currentName: '',
            tableData: [],
            columnWidth: 180,
        }
    },
    components: {
        AddBoardContent
    },
    watch: {},
    mounted() {
        this.initTableData('');
    },
    methods: {
        handleCurrentChange(val) {
            this.currPage = val;
            this.initTableData(this.keywords);
        },
        initTableData(keyword) {

            let user = JSON.parse(window.localStorage.getItem('user'));
            //console.log("useId:  " + user.id)


            this.getRequest('/web/messageInfo/queryToDoList?keyword=' + keyword + '&userId=' + user.id + '&currPage=' + this.currPage + '&pageSize=' + 10).then(resp => {
                //console.log(resp.data);
                if (resp) {
                    this.boardsTotal = resp.data.total;
                    this.tableData = resp.data.list;
                }
            });
        },
        doSearch() {
            //处理搜索逻辑
            this.initTableData(this.keywords);
        },
        changeName(name) {
            //console.log(this.currentName)
            this.currentName = name;
            if (name === '') {
                this.initTableData('');
                this.$store.commit('REMOVE_CURRENT_BOARD_ID');
            }
        },
        handleEdit1(obj) {
            this.getRequest("/web/messageInfo/updateState?messageId=" + obj.messageId + "&state=1").then(resp => {
                if (resp) {
                    this.$message.success("标记待办成功");
                    this.initTableData('');
                }
            });
        },
        handleEdit(obj) {
            this.getRequest("/web/messageInfo/updateState?messageId=" + obj.messageId + "&state=2").then(resp => {
                if (resp) {
                    this.$message.success("标记已办成功");
                    this.initTableData('');
                }
            });
        },
        handleDelete(obj) {
            this.$confirm('是否永久标题为：【' + obj.title + '】的消息通知？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.getRequest("/web/messageInfo/updateState?messageId=" + obj.messageId + "&state=0").then(resp => {
                    if (resp) {
                        this.$message.success("已删除");
                        this.initTableData('');
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        publishedSwitch(obj) {
            this.getRequest('/web/changeBoard/published?id=' + obj.id + '&published=' + obj.published).then(resp => {
            });
        },
        goToRegistration() {

        }
    }
}
</script>

<style scoped>
.table {
    margin: 20px 0;
    padding: 20px;
    background: #fff;
    border-radius: 4px;
}

.el-table {
    margin: 20px 0;
}

.el-row {
    margin-bottom: 20px;
}

.el-pagination {
    margin-top: 20px;
    text-align: center;
}

.el-input {
    margin-right: 10px;
}
</style>